import { Main } from './components/containers/Main';

const Profitability = () => <Main />;

export default Profitability;
